import * as React from 'react'

import Snackbar from '@mui/material/Snackbar'

import { ReactComponent as CloseIcon } from '../../assets/cross_close_logo.svg'

import { Box } from '@mui/material'
import { TypographyPrimary } from '../../ui/typography/TypographyPrimary'

import { ReactComponent as SuccessLogo } from '../../assets/vector_ok_logo.svg'
import { ReactComponent as ErrorLogo } from '../../assets/warning_notification.svg'

import { NotificationsTypes } from 'models/notifications'
import { useCallback, useEffect } from 'react'
import CattlesApiService from 'services/cattlesApiServices'
import { COLORS } from 'styles/colors'
import CustomButton from 'ui/buttons/CustomButton'
import { TypographyPrimary16Bold } from 'ui/typography/TypographyPrimary16Bold'
import { CHECKUP_SAVED_EVENT, CheckupSavedNotice } from 'utils/checkupWindow'
import { useAppDispatch, useAppSelector } from '../../store/hooks'
import {
	closeNotification,
	notifyUser,
	setShowModalEditCattlesQty,
	setShowWeightNotif,
} from '../../store/notificationsSlice'
import BarchartInfoLogo from 'assets/BarchartInfoLogo'

export default function Notification() {
	const { open, title, description, isError, isWarning, type, handleClose } =
		useAppSelector(store => store.notificationsSlice)
	const dispatch = useAppDispatch()
	const hasDescription = Boolean(description?.trim())
	const { isShowWeightNotif } = useAppSelector(
		store => store.notificationsSlice,
	)

	useEffect(() => {
		const onMessage = (event: MessageEvent) => {
			if (event.origin !== window.location.origin) return
			if (event.data?.type !== CHECKUP_SAVED_EVENT) return

			const notice = event.data.notice as CheckupSavedNotice
			dispatch(
				notifyUser({
					title: notice.title,
					description: notice.description ?? '',
					isError: Boolean(notice.isError),
				}),
			)
		}

		window.addEventListener('message', onMessage)
		return () => window.removeEventListener('message', onMessage)
	}, [dispatch])
	const handleCloseNotif = useCallback(
		(event: React.SyntheticEvent | Event, reason?: string) => {
			if (reason === 'clickaway') {
				return
			}
			if (reason === 'timeout') {
				dispatch(closeNotification())
				return
			}
			dispatch(closeNotification())
			if (handleClose) {
				handleClose()
			}
		},
		[dispatch, handleClose],
	)

	const noChangesNeeded = () => {
		CattlesApiService.postNoChangedNeededForCattlesQty().then(resonse => {
			if (resonse.status === 201) {
				dispatch(setShowWeightNotif({ isShowWeightNotif: false }))
				dispatch(
					notifyUser({
						title: 'Данные сохранены успешно',
						description: 'Вес раздач остался без изменений.',
						isError: false,
					}),
				)
			}
		})
	}
	return (
		<Snackbar
			anchorOrigin={{ horizontal: 'right', vertical: 'top' }}
			open={open}
			autoHideDuration={3000}
			onClose={handleCloseNotif}
			sx={{ marginRight: '-10px' }}
		>
			<Box
				sx={{
					backgroundColor: 'white',
					borderRadius: '8px',
					p: '16px',
					boxShadow: '0px 4px 16px 0px rgba(0, 0, 0, 0.08)',
					width: { xs: 'calc(100vw - 56px)', sm: '520px' },
					maxWidth: '560px',
				}}
				display='flex'
				flexDirection='column'
				justifyContent='space-between'
				gap='8px'
			>
				<Box
					display='flex'
					flexDirection='row'
					justifyContent='space-between'
					alignItems={hasDescription ? 'flex-start' : 'center'}
					gap='8px'
				>
					<Box
						sx={{
							width: '24px',
							height: '24px',
							display: 'flex',
							alignItems: 'center',
							justifyContent: 'center',
							flexShrink: 0,
						}}
					>
						{isWarning ? (
							<BarchartInfoLogo style={{ color: '#F09A37' }} />
						) : isError ? (
							<ErrorLogo />
						) : (
							<SuccessLogo />
						)}
					</Box>
					<Box
						display='flex'
						flexDirection='column'
						gap={hasDescription ? '10px' : 0}
						alignItems='flex-start'
						textAlign='left'
						sx={{ flex: 1, minWidth: 0 }}
					>
						<TypographyPrimary16Bold>{title}</TypographyPrimary16Bold>
						{description?.trim() && (
							<TypographyPrimary>{description}</TypographyPrimary>
						)}
						{isShowWeightNotif &&
							type === NotificationsTypes.DailyChangedWeight && (
								<Box
									sx={{ display: 'flex', flexDirection: 'row', gap: '16px' }}
								>
									<CustomButton
										title={'Изменить'}
										onClick={() => {
											dispatch(
												setShowModalEditCattlesQty({
													isShowModalEditCattlesQty: true,
												}),
											)
										}}
									/>
									<CustomButton
										title={'Оставить без изменений'}
										onClick={() => noChangesNeeded()}
									/>
								</Box>
							)}
					</Box>
					<Box
						sx={{ cursor: 'pointer', flexShrink: 0 }}
						onClick={e => handleCloseNotif(e)}
					>
						<CloseIcon stroke={COLORS.icon} style={{ width: '18px' }} />
					</Box>
				</Box>
			</Box>
		</Snackbar>
	)
}
